import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { patientConsentAtom } from "../../session/messages/state";
import { toast } from "../../toasts";
import { ConsentStatus } from "../../video-sdk";
import { RequestingClientConsentToast } from "./RequestingClientConsentToast";

const REQUESTING_CONSENT_TOAST_KEY = "requesting-client-consent-toast";

export function useRequestingClientConsentToast() {
  const patientConsent = useAtomValue(patientConsentAtom).value;
  const requestingClientConsent = patientConsent === ConsentStatus.DECIDING;

  useEffect(() => {
    if (requestingClientConsent) {
      toast.enqueue(RequestingClientConsentToast, {
        key: REQUESTING_CONSENT_TOAST_KEY,
        timeout: Infinity,
      });
    } else if (!requestingClientConsent) {
      toast.close(REQUESTING_CONSENT_TOAST_KEY);
    }
  }, [requestingClientConsent]);
}
